/*All transcription notify events should be updated here.*/
export enum TranscriptionNotifyEvent {
  AUDIO_PLAY,
  AUDIO_PAUSE,
  TRANSCRIPTION_PLAYBACK_MODE_ON,
  TRANSCRIPTION_PLAYBACK_MODE_CLOSED,
  TRANSCRIPION_LAUNCHED
}

//IEventNotifier is an interface which different EventNotifiers can implement.
export interface IEventListener {
  onReceive(event : TranscriptionNotifyEvent, payload? : any) : void;
}

export type PlaybackPayload = {
  audioPlayerState: number,
  timestamp: number,
  playbackSpeed: number
};